export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_RESEND = "FORGET_PASSWORD_RESEND"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGOT_PASSWORD_RESET = "FORGOT_PASSWORD_RESET"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"

export const FORGET_PASSWORD_UPDATE = "FORGET_PASSWORD_UPDATE"
export const FORGET_PASSWORD_UPDATE_SUCCESS = "FORGET_PASSWORD_UPDATE_SUCCESS"
export const FORGET_PASSWORD_UPDATE_ERROR = "FORGET_PASSWORD_UPDATE_ERROR"
export const RESET_FORGOT_PSWD_RESPONSE_MSG = "RESET_FORGOT_PSWD_RESPONSE_MSG"
